import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Step } from '../stepper/step';
import { StepsService } from '../../services/steps.service';
import { ICodeService } from '../../services/icode.service';
import { PasswordValidator } from '../../../globals/classes/password-validator';
import { UserData, IUserData } from '../../../globals/classes/userData';
import {
	ChangePassword,
	ChangePasswordRequest,
	IChangePasswordRequest,
} from '../../classes/change-password';
import { ComponentWithErrors } from '../../classes/component-with-errors';
import {
	IInitializePasswordRequest,
	InitializePasswordRequest,
} from '../../classes/initialize-password';
import { IUserIDRequest } from '../../classes/http-requests';
import { finalize } from 'rxjs/operators/finalize';
import { AppSettings } from '../../app.settings';

@Component({
	selector: 'change-password',
	template: require('./change-password.component.html'),
})
export class ChangePasswordComponent extends ComponentWithErrors implements OnInit {
	public steps: Step[];
	public isValidFrom = false;
	public changePassRequest: IChangePasswordRequest = new ChangePasswordRequest();
	public initRequest: IInitializePasswordRequest = new InitializePasswordRequest();
	public icode: string;
	public isValidPass: boolean;
	public errorMessage: string = null;
	public loading: boolean;
	public userId: string;
	public isNewChangePasswordModals: boolean = AppSettings.isNewChangePasswordModals;
	public isRebrading = AppSettings.isRebrading;

	private userData: IUserData = new UserData();
	constructor(
		public stepsService: StepsService,
		private activeModal: NgbActiveModal,
		private icodeService: ICodeService
	) {
		super();
	}

	public ngOnInit() {
		this.steps = this.stepsService.getTransactionSteps('ChangePasswordComponent');
		this.stepsService.setStep(this.steps, 0);
		UserData.data$.subscribe((data) => this.onUserDataReceived(data));
		this.mortalize(this.icodeService.code$).subscribe((c) => (this.icode = c));
		this.mortalize(this.icodeService.codeRequested$).subscribe(() => this.sendChangePass());
		this.mortalize(PasswordValidator.isValidPassAndConfirm$).subscribe(
			(val) => (this.isValidPass = val)
		);
		PasswordValidator.resetValidation();
	}

	public closeModal(): void {
		this.activeModal.close();
	}

	public proceed(): void {
		if (!this.canProceed) return;
		if (this.stepsService.getCurrentStep === 0) {
			this.sendChangePass();
		} else if (this.stepsService.getCurrentStep === 1) {
			this.changePassword();
		} else {
			this.handleError();
		}
	}

	public changePassword() {
		this.changePassRequest.otp = this.icode;
		this.loading = true;
		ChangePassword.ChangePassword(this.changePassRequest).subscribe(
			(res) => {
				this.loading = false;
				if (res && res.succeeded) {
					Object.assign(this.initRequest, {
						passwordConfirmNew: this.changePassRequest.newPasswordConfirm,
						passwordNew: this.changePassRequest.newPassword,
						userID: this.changePassRequest.userID,
					});
					this.stepsService.moveNextStep(this.steps);
				} else if (res && !res.succeeded && res.loginError == '7002') {
					let isLoginError: boolean = true;
					this.handlePassError(isLoginError);
				} else {
					this.handleError();
				}
			},
			(error) => {
				if (error && error.desc) {
					this.handleError();
					this.loading = false;
				}
			}
		);
	}

	public sendChangePass() {
		this.errorMessage = null;
		let request: IUserIDRequest = { UserID: this.changePassRequest.userID };
		this.loading = true;
		ChangePassword.SendChangeOtpPass(request)
			.pipe(finalize(() => (this.loading = false)))
			.subscribe(
				(res) => {
					if (res && res.succeeded === true) {
						this.userData.userId = request.UserID;
						this.userData.hasSMSOtp = res.hasOtp;
						this.userData.maskedPhoneNumber = res.maskedPhoneNumber;
						this.userData.isChangePass = true;
						UserData.update(this.userData);
						this.stepsService.moveNextStep(this.steps);
					} else {
						this.handleError();
					}
				},
				(error) => this.handleError(error)
			);
	}

	public get canProceed() {
		switch (this.stepsService.getCurrentStep) {
			case 0:
				return this.validPasswordForm;
			case 1:
				return this.validIcode;
			default:
				return false;
		}
	}
	private onUserDataReceived(data: IUserData): void {
		this.userId = data.userId;
		this.changePassRequest.userID = data.userId;
		this.initRequest.userID = data.userId;
	}

	private get hasPreviousPass(): boolean {
		if (!PasswordValidator.previousPassWord) return false;
		else return true;
	}

	private get validPasswordForm(): boolean {
		return !!this.userId && this.isValidPass && this.hasPreviousPass;
	}

	private get validIcode(): boolean {
		return !!this.icode && (this.icode.length === 6 || this.icode.length === 8);
	}
}
